<template>
  <div id="app">
    <form @submit.prevent class="container d-flex flex-column">
      <div class="row">
        <fieldset class="col-md-3">
          <legend>{{$t('form.search.legend')}}</legend>
          <ncs-search-type/>
        </fieldset>
        <fieldset class="col-md-9">
          <legend>{{$t('form.result.legend')}}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-result-type/>
            </div>
            <div class="col-md-6">
              <ncs-order-selector/>
            </div>
            <div class="col-md-3">
              <ncs-page-size-selector/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <display-kwic-header-check/>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row">
        <fieldset class="col-md-3">
          <legend>{{$t('form.sensibility.legend')}}</legend>
          <div class="row">
            <div class="col-md-6">
              <ncs-global-option name="case" :value="false"/>
            </div>
            <div class="col-md-6">
              <ncs-global-option name="ij" :value="false"/>
            </div>
            <div class="col-md-6">
              <ncs-global-option name="and_et" :value="false"/>
            </div>
            <div class="col-md-6">
              <ncs-global-option name="uv" :value="false"/>
            </div>
          </div>
        </fieldset>
        <fieldset class="col-md-9">
          <legend>{{$t('form.filters.legend')}}</legend>
          <div class="row">
            <div class="col-md-3">
              <ncs-select field="ncs_documents.outorgante"/>
            </div>
            <div class="col-md-3">
              <ncs-select field="ncs_documents.soporte"/>
            </div>
            <div class="col-md-3">
              <ncs-filter type="number" name="ncs_documents.data_desde_ano"
                                    field="ncs_documents.data_ata_ano_range"
                                    :min="501" :max="1500" operator="gteq"/>
            </div>
            <div class="col-md-3">
              <ncs-filter type="number" name="ncs_documents.data_ata_ano"
                                    field="ncs_documents.data_desde_ano_range"
                                    :min="500" :max="1499" operator="lteq"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <ncs-multi-select field="ncs_documents.identificador_edicion" :searchable="true"/>
            </div>
            <div class="col-md-3">
              <match-filter field="ncs_documents.unidade_arquivistica"/>
            </div>
            <div class="col-md-3">
              <range-filter field="ncs_documents.numero_rexistro"/>
            </div>
            <div class="col-md-3">
              <ncs-multi-select field="ncs_documents.tipo_rexistro"/>
            </div>
            <div class="col-md-3">
              <ncs-select field="ncs_texts.section"/>
            </div>
            <div class="col-md-3">
              <ncs-select field="ncs_documents.orixe"/>
            </div>
            <div class="col-md-3">
              <match-filter field="ncs_documents.procedencia"/>
            </div>
          </div>
        </fieldset>
      </div>
      <ncs-element-section/>
      <div class="btn-group align-self-end">
        <ncs-download-button/>
        <ncs-back-button/>
        <ncs-reset-button/>
        <ncs-search-button/>
      </div>
    </form>
    <ncs-result contact-link="#" contact-email="admin@nlpgo.com">
      <ncs-frequency-result/>
      <ncs-full-frequency-result/>
      <kwic-result-with-header/>
      <ncs-context-result :textHeader="false">
        <template slot="documentHeader" slot-scope="{document}">
          <context-header :document="document"/>
        </template>
      </ncs-context-result>
    </ncs-result>
  </div>
</template>


<script>
  import DisplayKwicHeaderCheck from './DisplayKwicHeaderCheck'
  import MatchFilter from './MatchFilter'
  import RangeFilter from './RangeFilter'
  import KwicResultWithHeader from './KwicResultWithHeader'
  import KwicHeader from './KwicHeader'
  import ContextHeader from './ContextHeader'

  export default {
    components: {
      DisplayKwicHeaderCheck,
      MatchFilter,
      RangeFilter,
      KwicResultWithHeader,
      KwicHeader,
      ContextHeader
    }
  }
</script>
<style lang="scss">
  @import "../scss/variables";

  legend {
    color: $primary;
    border-bottom: 1px solid $primary;
    font-size: 14px;
    margin-bottom: 5px;
  }

  label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }

  .form-group {
    margin-bottom: 0.25rem;
  }

  // TODO: Move this fix to ncs gem
  .multiselect {
    .multiselect__placeholder {
      margin-left: 0.25rem;
      margin-bottom: 0;
    }
  }
</style>
